import React from "react";
import * as Routes from "./routes/Routes";
import configRouters from "Configs/routes";
import { Route, Switch, withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import ProviderLayout from "Layouts/ProviderLayout";
import { observer, inject } from "mobx-react";
import { Redirect404 } from "ComponentsUI/Redirects";
import { pipe } from "Utils";

const ProviderDetails = (props) => {
	const text = props.ApplicationModel.text;

	return (
		<Switch>
			<ProviderLayout
				exact
				path={configRouters.ProvidersActionsList.route}
				seoData={props.seoData}
				component={Routes.ActionsList}
				seoPath="ProvidersActionsList"
			/>
			<ProviderLayout
				exact
				path={configRouters.ProviderDetails.route}
				seoData={props.seoData}
				component={Routes.Card}
				seoPath="ProviderDetails"
			/>
			<ProviderLayout
				exact
				path={configRouters.ProviderRates.route}
				seoData={props.seoData}
				component={Routes.Rates}
				seoPath="ProviderRates"
			/>
			<ProviderLayout
				exact
				path={configRouters.ProviderRatesTags.route}
				seoData={props.seoData}
				component={Routes.RatesTags}
				seoPath="ProviderRatesTags"
			/>
			<ProviderLayout
				exact
				path={configRouters.ProvidersConnectTariff.route}
				seoData={props.seoData}
				component={Routes.ConnectTariff}
				seoPath="ProvidersConnectTariff"
			/>
			<ProviderLayout
				exact
				path={configRouters.ProvidersReviewListOld.route}
				seoData={props.seoData}
				component={Routes.RatingReview}
				seoPath="ProvidersReviewListOld"
			/>
			<ProviderLayout
				exact
				path={configRouters.ReviewItem.route}
				seoData={props.seoData}
				component={Routes.ReviewItem}
				seoPath="ReviewItem"
				defaultHeader={text.REVIEW_BY_CLIENT_DEFAULT_HEADER}
				notH1={true}
			/>
			<Route render={Redirect404} />
		</Switch>
	);
};

export default pipe(
	observer,
	inject("ApplicationModel"),
	withDefaultParams,
	withRouter
)(ProviderDetails);
